import React from 'react';
import { CheckCircle2, Circle, Clock } from 'lucide-react';
import { BRAND } from '../kit/tokens';

// The six plain steps a borrower sees (backend borrower_status.borrower_status):
// { label, closed, steps: [{ key, label, reached }] }. Shared by the public loan
// status page and the borrower deal page so the two never word progress differently.
export default function BorrowerProgress({ progress }) {
  const steps = progress?.steps || [];
  if (steps.length === 0) return null;
  const current = steps.reduce((last, s, i) => (s.reached ? i : last), -1);
  return (
    <div data-testid="borrower-progress">
      {progress.closed && (
        <div className="text-sm text-slate-600 mb-4" data-testid="progress-closed-note">
          This file is closed. Please contact your loan officer with any questions.
        </div>
      )}
      <div className="overflow-x-auto">
        <div className="flex items-start min-w-[480px]">
          {steps.map((s, i) => (
            <div key={s.key} className="flex-1 relative flex flex-col items-center" data-testid={`stage-${s.key}`}>
              <div
                className={`w-8 h-8 rounded-full flex items-center justify-center z-10 ${s.reached ? 'text-white shadow' : 'bg-slate-100 text-slate-400'}`}
                style={s.reached ? { background: BRAND.accent } : {}}
              >
                {i < current ? <CheckCircle2 size={16} /> : i === current ? <Clock size={16} /> : <Circle size={16} />}
              </div>
              {i < steps.length - 1 && (
                <div className="absolute top-4 left-1/2 w-full h-0.5" style={{ background: i < current ? BRAND.accent : '#e2e8f0' }} />
              )}
              <div
                className={`text-[10px] uppercase tracking-wider mt-2 text-center px-1 ${s.reached ? 'font-bold' : 'text-slate-400'}`}
                style={s.reached ? { color: BRAND.navy } : {}}
              >
                {s.label}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
